import { render, staticRenderFns } from "./communityApplicationInformationDetail.vue?vue&type=template&id=6f873d96&"
import script from "./communityApplicationInformationDetail.vue?vue&type=script&lang=js&"
export * from "./communityApplicationInformationDetail.vue?vue&type=script&lang=js&"
import style0 from "./communityApplicationInformationDetail.vue?vue&type=style&index=0&id=6f873d96&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports